import React, { Component } from "react";

//<div>
  //<a
    //id="Chat"
    //href="https://goo.gl/forms/dVC3pUmkT87PTnS23"
    //target="_blank"
    //rel="noopener noreferrer"
  //>
    //Request for benefits, demo, and pricing.
  //</a>      
//</div>


class Chat extends Component {
  render() {
    return (
      <div>
        <a
          id="Chat"
          href="https://m.me/breakfasy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Chat with us on Messenger!
        </a>
      </div>
    );
  }
}

export default Chat;
